export const CREATE_SPRAY_SUBMISSION_MODAL = 'createSpraySubmissionModal';
